import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=ede44d06&scoped=true"
import script from "./errorModal.vue?vue&type=script&lang=js"
export * from "./errorModal.vue?vue&type=script&lang=js"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=ede44d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede44d06",
  null
  
)

export default component.exports